export const features = {
  enableResearchFeatures: import.meta.env.VITE_ENABLE_RESEARCH_FEATURES === 'true',
};
